import {html, render} from 'lit-html';
import "/styles/style.scss";


let sayHello = (name) => html`<h1>Hello ${name}</h1>`;

render(sayHello('World'), document.body);

render(sayHello('Everyones'), document.body);